import { Component, DestroyRef, inject, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ActivatedRoute } from '@angular/router';
import { TestTypes } from 'src/app/models/instance/test-types';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { UrlService } from 'src/app/services/util/url.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { DeploymentClass } from 'src/app/models/instance-class';
import { InstanceEnvironment } from 'src/app/models/instance-environment';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { Subscription } from 'rxjs';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import moment from 'moment';
import { AvailabilityStatus } from 'src/app/models/availability-status';
import { toUtcString } from 'src/app/services/util/utils';

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.EF_TEST_NONPII,
    name: Feature.EF_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.SANITY_TEST_NONPII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.SANITY_TEST_PII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.SANITY_TEST_LIVE,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
];

@Component({
  selector: 'app-environment-sanity-test',
  templateUrl: './environment-sanity-test.component.html',
  styleUrls: ['./environment-sanity-test.component.scss'],
  standalone: false,
})
export class EnvironmentSanitytestComponent implements OnInit {
  @ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @Output() updateInstnace = new EventEmitter();
  @Input() data: any;
  @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
  private destroyRef = inject(DestroyRef);
  instanceId: any;
  testResultsTotal = 0;
  clientName: any;
  isAWS: boolean;
  loadDataSubscription: Subscription;
  DeploymentClass = DeploymentClass;
  pageConfigurationStates: ConfigurationState[];
  filteredConfigurationStates: ConfigurationState[];
  FeatureKeys = FeatureKeys;
  showSpinner: boolean = true;
  dataSourceSanityTestResults: any;
  sanityTestResults: any[] = [];
  efTestResults: any[] = [];
  sanityPaginationSize = 10;
  pageIndex = 0;
  sanityTest = true;
  isSanityTestInprogress = false;
  isEFTestInprogress = false;
  availableConfigLoaded = false;
  featuresMap: any = {};
  showPagination: any;
  deploymentLog: any;
  sortInfo: any;
  filteredDeploymentLog: any;
  deploymentLogData: any;
  updatedLog: any;
  updatedLogData: any;
  expandedElement: null;
  dataSourceLog: any;
  filteredUpdateLog: any;
  paginationSize = 10;
  dataSourceUpdateLog: any;
  routeData: any;
  dataSource: any;
  instance: any;
  isRefreshing: boolean = false;
  searchTerm: string = '';
  searchedResult = [];
  sanityTestStatus: any;
  dropdownsList: any;
  filteredColumns: any;
  isFiltered = false;
  clearData: boolean;
  filterStartDate: any;
  filterEndDate: any;
  selectedStatus = [];
  status: any;
  sanityTestData: any[] = [];
  isViewAllowed: boolean = false;
  isExecuteAllowed: boolean = false;
  showLoader:boolean = false;
  AvailabilityStatus = AvailabilityStatus;
  // Table columns
  displayColumns = [
    {
      key: 'testStartTime',
      name: 'SANITY_TEST.START_DATE',
      type: 'date',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'testFinishTime',
      name: 'SANITY_TEST.END_DATE',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'duration',
      name: 'SANITY_TEST.DURATION',
      type: 'duration',
      startKey: 'testStartTime',
      endKey: 'testFinishTime',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'initiatedBy',
      name: 'SANITY_TEST.INITIATED_BY',
      type: 'userIcon',
      visible: true,
      disable: false,
      sortable: false
    },
    {
      key: 'status',
      name: 'SANITY_TEST.STATUS',
      type: 'status',
      visible: true,
      disable: true,
      sortable: true
    },
    {
      key: 'testResultsPath',
      name: 'SANITY_TEST.RESULT',
      type: 'result',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'sanityTestSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true
    }
  ];
  readonly EXCECUTETEST_ENABLE_STATES = [
    DeployStatus.DEPLOYED,
    DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED,
    DeployStatus.CONFIGURED,
    DeployStatus.CONFIGURATION_FAILED,
    DeployStatus.TESTED,
    DeployStatus.FAILOVER_FAILED,
    DeployStatus.FAILBACK_FAILED,
    DeployStatus.PRE_FAILBACK_FAILED,
    DeployStatus.POST_FAILBACK_FAILED,
    DeployStatus.STOP_FAILED
  ];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED,
  DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
  DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.INITIALIZING,
  DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.INPROGRESS];

  constructor(
    private dialog: MatDialog, private instanceService: InstancesService, public urlService: UrlService, private route: ActivatedRoute,
    private toastrService: CustomToastrService, private crvtService: CRVTService, private tenantService: TenantService,
    private featurePermissionsService: FeaturePermissionsService, private changeDetectorRef: ChangeDetectorRef,
    private sidenavService: SidenavService
  ) { }

  //  MAIN FUNCTION
  ngOnInit(): void {
    this.instanceId = this.route.snapshot.params.instanceId;
    this.instance = this.data;
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS;
    });
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
    this.isViewAllowed = this.featuresMap[FeatureKeys.SANITY_TEST_NONPII] || this.featuresMap[FeatureKeys.SANITY_TEST_PII] || this.featuresMap[FeatureKeys.SANITY_TEST_LIVE];
    this.isExecuteAllowed = ((this.data.deploymentClass === DeploymentClass.D || this.data.deploymentClass === DeploymentClass.C) &&
      this.featuresMap[FeatureKeys.SANITY_TEST_NONPII]) || (this.data.deploymentClass === DeploymentClass.B &&
        this.featuresMap[FeatureKeys.SANITY_TEST_PII]) || (this.data.deploymentClass === DeploymentClass.A &&
          this.featuresMap[FeatureKeys.SANITY_TEST_LIVE])
    this.updateEnvironment(this.data);
    if (localStorage.getItem('filteredSanityTestStatus')) {
      const userData = JSON.parse(localStorage.getItem('filteredSanityTestStatus'));
      if (userData) {
        this.selectedStatus = userData;
        this.sanityTestStatus = this.selectedStatus;
        this.dropdownsList?.[1]?.options?.forEach(element => {
          if (this.selectedStatus.find(item => item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.getTestResults(this.instanceId);
    this.resetSanityTestFilter();
  }

  public getTestResults(id, testType?: String, page?: Number, size?: Number): void {
    this.showLoader = true;
    this.isSanityTestInprogress = false;
    this.instanceService.getTestResults(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(results => {
        this.testResultsTotal = results?.total;
        if (Number(results?.total) > 10) {
          this.instanceService.getTestResults(id, results?.total)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(totalResults => {
              this.availableConfigLoaded = true;
              this.sanityEfData(totalResults);
            },
              (error) => {
                setTimeout(() => {
                  const title = translate('ERRORS.SERVICE_AVAILABILITY');
                  const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
                  this.toastrService.errMessage(message, title);
                }, 500);
                this.availableConfigLoaded = true;
              });
        } else {
          this.availableConfigLoaded = true;
          this.sanityEfData(results);
        }
      }, (error) => {
        this.showLoader = false;
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        this.availableConfigLoaded = true;
      });
  }

  /* Separate sanity & EF tests */
  sanityEfData(results): void {
    this.sanityTestResults = results.data?.filter(item =>
      item.testType === TestTypes.SANITY_TEST
    );
    if (this.sanityTestResults?.find(item => item.status === 'inprogress')) {
      this.isSanityTestInprogress = true;
    }
    this.sanityTestResults = this.sanityTestResults?.sort((a, b) => new Date(b.testStartTime).getTime() - new Date(a.testStartTime).getTime());
    this.sanityTestResults = this.sanityTestResults?.map(item => ({
      ...item,
      testStartTime: item.testStartTime ? toUtcString(item.testStartTime) : null,
      testFinishTime: item.testFinishTime ? toUtcString(item.testFinishTime) : null
    }));
    this.efTestResults = results.data?.filter(element =>
      element.testType === TestTypes.EF_TEST
    );
    if (this.efTestResults?.find(item => item.status === 'inprogress')) {
      this.isEFTestInprogress = true;
    }
    this.efTestResults = this.efTestResults?.sort((a, b) => new Date(b.testStartTime).getTime() - new Date(a.testStartTime).getTime());
     this.efTestResults = this.efTestResults?.map(item => ({
      ...item,
      testStartTime: item.testStartTime ? toUtcString(item.testStartTime) : null,
      testFinishTime: item.testFinishTime ? toUtcString(item.testFinishTime) : null
    }));
    this.sanityTestData = this.sanityTestResults;
    this.showLoader = false;
    this.initializeFilterItems();
  }

  /** Environment update helper */
  updateEnvironment(data) {
    switch (data.deploymentClass) {
      case DeploymentClass.D:
        this.data.environment = InstanceEnvironment.DEV;
        break;
      case DeploymentClass.C:
        this.data.environment = InstanceEnvironment.TEST;
        break;
      case DeploymentClass.B:
        this.data.environment = InstanceEnvironment.PREPROD;
        break;
      case DeploymentClass.A:
        this.data.environment = InstanceEnvironment.LIVE;
        break;
    }
  }

  public excecuteSanityTest(): void {
    if (!this.isSanityTestInprogress && this.EXCECUTETEST_ENABLE_STATES.includes(this.data?.status)) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('TEST_RESULTS.SANITY_TEST_TITLE'),
          message: translate('TEST_RESULTS.SANITY_TEST_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.isSanityTestInprogress = true;
            this.instanceService.putSanityTest(this.instanceId)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(results => {
                if (results) {
                  this.getTestResults(this.instanceId, TestTypes.SANITY_TEST);
                  this.updateInstnace.emit(this.isSanityTestInprogress);
                  this.instanceService.triggerRefresh();
                }
              },
                (error) => {
                  const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
                  this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.SANITY_TEST_TITLE'),
                      description: errorMessage
                    }
                  });
                });
          }
        });
    }
  }

  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }

  refreshClick(): void {
    this.isRefreshing = true;
    this.availableConfigLoaded = false;
    if (this.isFiltered) {
      setTimeout(() => {
        this.isRefreshing = false;
        this.availableConfigLoaded = true;
      }, 1000);
      return;
    }
    if (this.paginatorRef) {
      this.paginatorRef.pageIndex = 0;
    }
    this.getTestResults(this.instanceId);
    setTimeout(() => {
      this.isRefreshing = false;
      this.availableConfigLoaded = true;
    }, 1000);
  }

  resetPaginator() {
    this.pageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }

  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

  searchedItems(result): void {
    this.searchedResult = result;
    this.changeDetectorRef.detectChanges();
  }

  initializeFilterItems() {

    this.sanityTestStatus = [
      { value: 'inprogress', label: "In Progress", selected: false },
      { value: 'success', label: "Success", selected: false },
      { value: 'failed', label: "Failed", selected: false }
    ];

    this.dropdownsList = [
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: this.sanityTestStatus
      }
    ];
  }

  /* Filters the table data based on the currently selected filter criteria */
  filterColumns(): void {
    if (this.sanityTestStatus) {
      this.dropdownsList[0].options.filter((item) => {
        if (this.sanityTestStatus?.find(status => status === item.value)) {
          item.selected = true;
        }
      });
    }
    const data = {
      name: translate('TEST_RESULTS.SANITY_TEST'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      dateCreated: this.instance?.dateCreated,
      sanityTestStatusList: this.dropdownsList?.[0].options,
      sanityTestColumns: [
        'status'
      ]
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        this.filteredColumns = filteredColumns;
        if (filteredColumns) {
          this.isFiltered = true;
          this.clearData = true;
          if (filteredColumns[0] !== '') {
            this.sanityTestStatus = filteredColumns[0];
          }
          if (filteredColumns[0]?.length === 0) {
            this.resetSanityTestFilter();
          } else {
            this.filtersanityTestItems(filteredColumns);
          }
        }
      });
  }

  /* Filters the sanityTest table data based on the selected filter criteria. */
  filtersanityTestItems(filteredColumns): void {
    if (filteredColumns) {
      this.sanityTestResults = this.sanityTestData;
      this.selectedStatus = [];
      if (filteredColumns[0]?.length > 0) {
        this.selectedStatus = filteredColumns[0];
        if (filteredColumns[0].length > 0) {
          localStorage.setItem('filteredSanityTestStatus', JSON.stringify(this.selectedStatus));
          this.sanityTestResults = this.sanityTestResults?.filter(item => this.selectedStatus?.includes(item?.status));
        } else {
          localStorage.removeItem('filteredSanityTestStatus');
        }
      }
    }
  }

  /* Returns a label for the Status */
  getStatusLabel(status): void {
    return this.selectedStatus?.find(item => item.value === status)?.label || status || '';

  }

  cancelStatusFilter(data) {
    let selectedItem = this.selectedStatus.indexOf(data);
    if (selectedItem > -1) {
      localStorage.removeItem('filteredSanityTestStatus');
      this.selectedStatus.splice(selectedItem, 1);
      this.dropdownsList[0].options.find(item => item.value === data).selected = false;
      localStorage.setItem('filteredSanityTestStatus', JSON.stringify(this.selectedStatus));
      this.filtersanityTestItems(this.filteredColumns);
    }
  }

  /* Reset the selected sanityTestResults filter */
  resetSanityTestFilter(): void {
    this.isFiltered = false;
    this.selectedStatus = [];
    this.sidenavService.searchFilter.next('data');
    this.dropdownsList?.[0]?.options?.filter((item) => { item.selected = false });
    this.status = undefined;
    this.sanityTestStatus = undefined;
    this.sanityTestResults = this.sanityTestData;
    localStorage.removeItem('filteredSanityTestStatus');
  }
}